var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{staticClass:"mt-4"},[_c('v-col',{staticClass:"col-sm-12 col-md-10 offset-sm-0 offset-md-1"},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }